(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cons-inf-account', {
            parent: 'entity',
            url: '/cons-inf-account',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfAccount.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-accounts.html',
                    controller: 'ConsInfAccountController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfAccount');
                    $translatePartialLoader.addPart('tipoInvio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cons-inf-account-detail', {
            parent: 'cons-inf-account',
            url: '/cons-inf-account/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.consInfAccount.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-detail.html',
                    controller: 'ConsInfAccountDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('consInfAccount');
                    $translatePartialLoader.addPart('tipoInvio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ConsInfAccount', function($stateParams, ConsInfAccount) {
                    return ConsInfAccount.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cons-inf-account',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cons-inf-account-detail.edit', {
            parent: 'cons-inf-account-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-dialog.html',
                    controller: 'ConsInfAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfAccount', function(ConsInfAccount) {
                            return ConsInfAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-account.new', {
            parent: 'cons-inf-account',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-dialog.html',
                    controller: 'ConsInfAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                address: null,
                                email: null,
                                legalEmail: null,
                                asciiArmor: null,
                                phoneNumber: null,
                                country: null,
                                vat: null,
                                creationDate: null,
                                renewalDate: null,
                                tipoInvio: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cons-inf-account', null, { reload: 'cons-inf-account' });
                }, function() {
                    $state.go('cons-inf-account');
                });
            }]
        })
        .state('cons-inf-account.edit', {
            parent: 'cons-inf-account',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-dialog.html',
                    controller: 'ConsInfAccountDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConsInfAccount', function(ConsInfAccount) {
                            return ConsInfAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-account', null, { reload: 'cons-inf-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cons-inf-account.delete', {
            parent: 'cons-inf-account',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cons-inf-account/cons-inf-account-delete-dialog.html',
                    controller: 'ConsInfAccountDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ConsInfAccount', function(ConsInfAccount) {
                            return ConsInfAccount.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cons-inf-account', null, { reload: 'cons-inf-account' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
